import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  columnsWrapper: {
    "@media (max-width: 48em)": {
      gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    },
  },
}));
